import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { Button, FlagIcon, ToggleableOption } from '@/components';
import { useRegionPreferenceManagement } from '@/hooks';
import { AnalyticsService } from '@/services';
import { useSetRegionPreferenceMutation } from '@/store';
import { Location } from '@/types';

export const RegionSwitchMenuContents = ({
  onClose,
  location,
}: {
  onClose?: () => void;
  location?: Location;
}) => {
  const onOptionClick = async (slug: string) => {
    const newRegionList = tempSelectedRegions.includes(slug)
      ? tempSelectedRegions.filter(region => region !== slug)
      : [...tempSelectedRegions, slug];
    if (newRegionList.length === 0) return;
    await setTempSelectedRegions(newRegionList);
  };
  const [setRegionPreference] = useSetRegionPreferenceMutation();

  const { regionOptions, selectedRegions } = useRegionPreferenceManagement();

  const [tempSelectedRegions, setTempSelectedRegions] = useState<string[]>([]);

  useEffect(() => {
    if (selectedRegions) setTempSelectedRegions([...selectedRegions]);
  }, [selectedRegions]);

  const onSubmit = () => {
    setRegionPreference({ regionSlugs: tempSelectedRegions });
    AnalyticsService.updateContentPreferenceRegions({
      previousValue: selectedRegions ?? [],
      newValue: tempSelectedRegions,
      location,
    });
    onClose?.();
  };

  const onCancel = () => {
    setTempSelectedRegions(selectedRegions ?? []);
    onClose?.();
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1.5 }}>
        {regionOptions?.map((option, index) => (
          <ToggleableOption
            key={index}
            label={option.value}
            isSelected={tempSelectedRegions.includes(option.slug)}
            onClick={() => onOptionClick(option.slug)}
            startIcon={<FlagIcon region={option.slug} width={24} />}
          />
        ))}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          mt: 2,
        }}>
        <Button
          variant="secondary"
          label="Cancel"
          fullWidth={false}
          skinny={false}
          sx={{ flex: 1 }}
          onClick={onCancel}
        />
        <Button
          variant="primary"
          label="Save"
          fullWidth={false}
          skinny={false}
          sx={{ flex: 1 }}
          onClick={onSubmit}
        />
      </Box>
    </>
  );
};
